module.exports = __webpack_public_path__ + "img/md.ffde6acb.svg";